module.exports = __webpack_public_path__ + "img/astropay.f6964495.svg";